import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { envApiUrl } from './envApiUrl';

export const useHealthmetrictypes = () => {
  return useQuery({
    queryKey: ['useHealthmetrictypes'],
    queryFn: () =>
      axios
        .get(`${envApiUrl}/healthmetrictypes/`, {
          headers: {
            'Content-Type': 'application/json',
          },
          withCredentials: true,
          xsrfCookieName: 'csrftoken',
          xsrfHeaderName: 'x-csrf-token',
        })
        .then((response) => {
          return response.data;
        })
        .catch((error) => {
          if (error.response) {
            console.log('AAA: ', error.response.data);
            console.log(error.response.status);
            console.log(error.response.headers);
          }
          if (error.response?.status === 403) {
            console.log('TRYING TO SIGN OUT AND REDIRECT DUE TO ERROR RESPONSE FROM SERVER');
            window.location.href = '/';
          }
        }),
  });
};
